export function initSubMenu() {


    // Function to remove 'open' class from all child 'ul' elements
    function removeOpenClass() {
        document.querySelectorAll('.site-menu li.has-children ul.open').forEach(function(openUl) {
            openUl.classList.remove('open');
        });
    }

    // Select all 'li' elements with class 'has-children'
    var listItems = document.querySelectorAll('.site-menu li.has-children');
    var timer;

    listItems.forEach(function(li) {
        // Mouseover event to add 'open' class and remove from others
        li.addEventListener('mouseover', function() {
            clearTimeout(timer);  // Clear any existing timer
            removeOpenClass(); // Remove 'open' class from all other instances

            var childUl = li.querySelector('ul');
            if (childUl) {
                childUl.classList.add('open');
            }
        });

        // Mouseout event to start timer and remove 'open' class
        li.addEventListener('mouseout', function() {
            timer = setTimeout(function() {
                removeOpenClass();
            }, 350); //
        });
    });



}
